import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

// Dodecaedro 3D object
var dodecaedro
const dodecaedroLoader = new GLTFLoader()

var rotX = 3 //+ 2 * Math.random()
var rotY = 3.79 //- 2 * Math.random()
var rotZ = 1 //* Math.random()

dodecaedroLoader.load('./Dodecaedro_decimate_planar_10deg.gltf', (gltf) => {
   
    dodecaedro = gltf.scene
    dodecaedro.scale.set(1, 1, 1)
    dodecaedro.rotation.set(rotX, rotY, rotZ)
    
    scene.add(dodecaedro)    

})

// LUCI
// Luce 1 ambientale
const pointLight = new THREE.AmbientLight(0xffffff, 0.45)
scene.add(pointLight)
// Luce 2
const pointLight2 = new THREE.PointLight(0xffffff, 5)
pointLight2.position.set(3, 0, -2)
scene.add(pointLight2)
// Luce 3
const pointLight3 = new THREE.PointLight(0xffffff, 6)
pointLight3.position.set(-1, 0, -5)
scene.add(pointLight3)
// Luce 4
const pointLight4 = new THREE.PointLight(0xffffff, 7)
pointLight4.position.set(-1, 0, 3)
scene.add(pointLight4)
// Luce 5
const pointLight5 = new THREE.PointLight(0xffffff, 4)
pointLight5.position.set(3, 3, 0)
scene.add(pointLight5)
// Luce 6
const pointLight6 = new THREE.PointLight(0xffffff, 4)
pointLight6.position.set(-3, -3, 0)
scene.add(pointLight6)

// Sizes
const sizes = {
    //width: window.innerWidth,
    //height: window.innerHeight
    width: 450,
    height: 450
}
var isMobile = Math.min(window.screen.width, window.screen.height) < 768;
if (isMobile) {
    sizes.width = 200;
    sizes.height = 200;
}

// PER RESPONSIVENESS
window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

// Camera
const camera = new THREE.PerspectiveCamera(65, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 0
camera.position.y = 3
camera.position.z = 3.5
scene.add(camera)

// Renderer
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    alpha: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
document.body.appendChild(renderer.domElement);

// Interattività sia con mouse+click che da smartphone. NB: Quando si usano queste due righe la GUI non è più attiva
let controls = new OrbitControls(camera, renderer.domElement);

// Animate
const clock = new THREE.Clock()
const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    if (dodecaedro) {
    dodecaedro.rotation.x += 0.003;
    dodecaedro.rotation.y += 0.003;
    //dodecaedro.rotation.z += 0.001;
}

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()